import { css } from 'styled-components/macro';
import { COLORS } from './colors';

export const empty = () => css``;

export const redUnderline = css`
  text-decoration: underline;
  text-decoration-color: ${COLORS.red};
  text-decoration-thickness: 2px;
  text-underline-offset: 3px;
`;

export const hoverRed = css`
  cursor: pointer;
  &:hover {
    color: ${COLORS.red};
    ${redUnderline};
  }
`;

export const largerClickableArea = (size: number) => css`
  ::before {
    content: '';
    position: absolute;
    top: -#{$size}rem;
    right: -#{$size}rem;
    bottom: -#{$size}rem;
    left: -#{$size}rem;
  }
`;

export const fullWidthExpand = css`
  width: 100vw;
  margin-inline: 50%;
  transform: translateX(-50%);
`;

export const dataAlign = css`
  &[data-align='left'] {
    text-align: left;
  }

  &[data-align='center'] {
    text-align: center;
  }

  &[data-align='right'] {
    text-align: right;
  }
`;
